// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tipStyle[data-v-ac9b4c04] {\n  font-size: 12px;\n  color: #999;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
